import React, { createContext, useContext, useState, useEffect } from "react";

export const TwilioTemplatableContext = createContext();

export function useTwilioTemplatableContext() {
  return useContext(TwilioTemplatableContext);
}

export const TwilioTemplatableProvider = (props) => {
  const { templatableContext, templatable, twilioMessagingServices } = props;

  const {
    csrfToken,
    team,
  } = templatableContext();

  const getInitialMessagingServiceId = () => {
    // If template already has one, use it
    if (templatable.twilio_template?.twilio_messaging_service_id) {
      return templatable.twilio_template.twilio_messaging_service_id;
    }
    // Auto-select if there's exactly 1 messaging service
    if (twilioMessagingServices?.length === 1) {
      return twilioMessagingServices[0].id;
    }
    return "";
  };

  const [twilioTemplate, setTwilioTemplate] = useState(templatable.twilio_template);
  const [twilioMessagingServiceId, setTwilioMessagingServiceId] = useState(getInitialMessagingServiceId());

  useEffect(() => {
    setTwilioTemplate(templatable.twilio_template);
    setTwilioMessagingServiceId(
      templatable.twilio_template?.twilio_messaging_service_id ||
      (twilioMessagingServices?.length === 1 ? twilioMessagingServices[0].id : "")
    );
  }, [templatable]);

  const value = {
    ...props,
    csrfToken,
    team,
    templatable,
    twilioTemplate,
    twilioMessagingServiceId,
  };

  return (
    <TwilioTemplatableContext.Provider value={value}>
      {props.children}
    </TwilioTemplatableContext.Provider>
  );
};
